import { useEffect } from 'react';

// Body attribute toggled while >=1 sticky proposal footer is mounted. A global
// CSS rule in design-system.css keys off this SAME literal string to lift toasts
// above the footer (desktop only). Keep the two in sync — CSS cannot import this.
export const STICKY_FOOTER_TOAST_ATTR = 'data-sticky-footer-visible';

let mountedFooterCount = 0;

function acquireStickyFooterLift(): void {
  mountedFooterCount += 1;
  document.body.setAttribute(STICKY_FOOTER_TOAST_ATTR, 'true');
}

function releaseStickyFooterLift(): void {
  mountedFooterCount = Math.max(0, mountedFooterCount - 1);
  if (mountedFooterCount === 0) {
    document.body.removeAttribute(STICKY_FOOTER_TOAST_ATTR);
  }
}

/**
 * While mounted, marks that a sticky proposal footer is visible so global CSS can
 * lift toasts above it. Ref-counted so concurrent footers (actions page + a
 * proposal slideout) keep the flag set until the last one unmounts.
 */
export function useStickyFooterToastLift(): void {
  useEffect(() => {
    acquireStickyFooterLift();
    return releaseStickyFooterLift;
  }, []);
}
